export function defaultAiSettings(): AiSettings
{
    return {
        isEnabled: false,
        aiProviders: [{
            name: '',
            label: '',
            apiKey: '',
            endpoint: '',
            apiVersion: ''
        }],
        aiModels: [{
            aiProviderName: '',
            owner: '',
            name: '',
            version: '',
            label: '',
            type: '',
            isDefault: false
        }]
    };
}
